import type { Questionnaire } from '@medplum/fhirtypes'
import {
  getComputationQuestionnaireItem,
  VALIDATED_TOOL_SUMMARY_ITEM,
  VALIDATED_TOOL_TAG,
} from '#src/models/questionnaires/utils/index.ts'
import { QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL } from '#src/structureDefinitions.ts'

export const tugQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/TUG',
  status: 'active',
  subjectType: ['Patient'],
  name: 'TUG',
  title: 'Timed Up & Go Questionnaire (TUG)',
  meta: {
    tag: [VALIDATED_TOOL_TAG],
  },
  item: [
    {
      linkId: 'instructions',
      type: 'group',
      item: [
        {
          linkId: 'instructions-1',
          type: 'display',
          text: 'Purpose: to assess mobility',
        },
        {
          linkId: 'instructions-2',
          type: 'display',
          text: 'Equipment: a stopwatch',
        },
        {
          linkId: 'instructions-3',
          type: 'display',
          text: 'Directions: Patients wear their regular footwear and can use a walking aid, if needed. Begin by having the patient sit back in a standard arm chair and identify a line 3 meters, or 10 feet away, on the floor.',
        },
      ],
    },
    {
      linkId: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
      type: 'display',
      text: 'TUG PDF',
      extension: [
        {
          url: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
          valueString:
            'https://www.cdc.gov/steadi/media/pdfs/STEADI-Assessment-TUG-508.pdf',
        },
      ],
    },
    {
      linkId: 'questions',
      type: 'group',
      item: [
        {
          linkId: '89423-8',
          type: 'decimal',
          text: 'Time in seconds',
          required: true,
        },
        {
          linkId: 'observation-title',
          type: 'display',
          text: 'Observations',
        },
        {
          linkId: 'obs-1',
          type: 'boolean',
          text: 'Slow tentative pace',
          required: false,
        },
        {
          linkId: 'obs-2',
          type: 'boolean',
          text: 'Loss of balance',
          required: false,
        },
        {
          linkId: 'obs-3',
          type: 'boolean',
          text: 'Short strides',
          required: false,
        },
        {
          linkId: 'obs-4',
          type: 'boolean',
          text: 'Little or no arm swing',
          required: false,
        },
        {
          linkId: 'obs-5',
          type: 'boolean',
          text: 'Steadying self on walls',
          required: false,
        },
        {
          linkId: 'obs-6',
          type: 'boolean',
          text: 'Shuffling',
          required: false,
        },
        {
          linkId: 'obs-7',
          type: 'boolean',
          text: 'En bloc turning',
          required: false,
        },
        {
          linkId: 'obs-8',
          type: 'boolean',
          text: 'Not using assistive device properly',
          required: false,
        },
      ],
    },
    getComputationQuestionnaireItem(),
    VALIDATED_TOOL_SUMMARY_ITEM,
  ] as const,
} satisfies Questionnaire
